/* Add kit: each component is its own cart line. Spark records untouched. */
(function () {
  var kits = window.GPC_KITS;
  if (!kits || !kits.length) return;

  function toast(msg) {
    var el = document.createElement('div');
    el.className = 'fixed bottom-6 left-1/2 -translate-x-1/2 bg-zinc-800 border border-zinc-600 text-xs px-4 py-2 rounded-2xl shadow z-[70]';
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2200);
  }

  function addKit(kit) {
    var items = (kit.items || []).map(function (it) {
      return { id: it.id, quantity: 1 };
    });
    if (!items.length) {
      toast('Nothing in this kit is in stock.');
      return Promise.reject(new Error('empty kit'));
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || (data && data.status && data.status !== 200)) {
          throw new Error((data && (data.description || data.message)) || 'Add to cart failed');
        }
        return data;
      });
    });
  }

  document.querySelectorAll('[data-kit-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-kit-add');
      var kit = null;
      kits.forEach(function (k) { if (k.id === id) kit = k; });
      if (!kit) return;
      btn.disabled = true;
      addKit(kit)
        .then(function () {
          if (typeof window.syncCartFromShopify === 'function') {
            return window.syncCartFromShopify();
          }
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          btn.disabled = false;
          toast(err.message || 'Could not add kit');
        });
    });
  });
})();
